import { Grid } from '@mui/material';
import { useRedirectPqrFilters } from './hook';
import { RedirectPqrFiltersProps } from './props';
import FieldText from '../../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../shared/utils/params';
import { Checkbox } from '../../../../components/general/fields/checkbox';

export const RedirectPqrFilters = ({
    onFilter,
    loading,
}: RedirectPqrFiltersProps) => {
    const { formik, areas } = useRedirectPqrFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Correos"
                    name="extra"
                    size="small"
                    touched={formik.touched.extra}
                    errors={formik.errors.extra}
                    value={formik.values.extra}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <AutocompleteField
                    data={formatParams(areas)}
                    label="Área"
                    name="parent"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.parent}
                    errors={formik.errors.parent}
                    value={formik.values.parent}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('parent', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
